import { Plugin } from '@ckeditor/ckeditor5-core';
import RecorderUtils from '../recorderutils';
import ResizeRecorderCommand from './resizerecordercommand';

export default class RecorderResizeEditing extends Plugin {
    static get requires() {
        return [ RecorderUtils ];
    }

    static get pluginName() {
        return 'RecorderResizeEditing';
    }

    constructor(editor) {
        super(editor);

        editor.config.define('recorder', {
            resizeUnit: '%',
            resizeOptions: [
                { name: 'resizeRecorder:original', value: null, icon: 'original' },
                { name: 'resizeRecorder:25', value: '25', icon: 'small' },
                { name: 'resizeRecorder:50', value: '50', icon: 'medium' },
                { name: 'resizeRecorder:75', value: '75', icon: 'large' },
                { name: 'resizeRecorder:100', value: '100', icon: 'large' }
            ]
        });
    }

    init() {
        const editor = this.editor;
        const resizeRecorderCommand = new ResizeRecorderCommand(editor);

        this._registerSchema();
        this._registerConverters();

        editor.commands.add('resizeRecorder', resizeRecorderCommand);
        editor.commands.add('recorderResize', resizeRecorderCommand);
    }

    _registerSchema() {
        if (this.editor.model.schema.isRegistered('recorderBlock')) {
            this.editor.model.schema.extend('recorderBlock', { allowAttributes: 'width' });
        }
    }

    _registerConverters() {
        const editor = this.editor;

        // Downcast (modelo → vista)
        editor.conversion.for('downcast').add(dispatcher =>
            dispatcher.on(`attribute:width:recorderBlock`, (evt, data, conversionApi) => {
                if (!conversionApi.consumable.consume(data.item, evt.name)) return;

                const writer = conversionApi.writer;
                const container = conversionApi.mapper.toViewElement(data.item);

                if (data.attributeNewValue !== null) {
                    writer.setStyle('width', data.attributeNewValue, container);
                    writer.addClass('recorder_resized', container);
                } else {
                    writer.removeStyle('width', container);
                    writer.removeClass('recorder_resized', container);
                }
            })
        );

        // Upcast (vista → modelo)
        editor.conversion.for('upcast').attributeToAttribute({
            view: {
                name: 'figure',
                styles: { width: /.+/ }
            },
            model: {
                key: 'width',
                value: viewElement => viewElement.getStyle('width')
            }
        });
    }
}
